import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from '../InvoicesList.module.scss';

const Status = ({ item }) => {
  const options = {
    0: {
      style: styles.new,
      name: 'New'
    },
    1: {
      style: styles.pending,
      name: 'Pending'
    },
    2: {
      style: styles.paid,
      name: 'Paid'
    },
    3: {
      style: styles.overdue,
      name: 'Overdue'
    }
  };
  return (
    <div className={options[item].style}>
      <FormattedMessage id={`invoice.list.table.status.${options[item].name}`} defaultMessage={options[item].name} />
    </div>
  );
};

Status.propTypes = {
  item: PropTypes.number.isRequired
};
export default Status;
